import HistoryIcon from "@assets/icons/HistoryIcon"
import { CustomNavigate } from "@UI/CustomNavigate"
import { Row, Typography } from "antd"
import './styles.css'
import useCurrentLocation from "@thooks/useCurrentLocation"
import { useState } from "react"
import LogsDrawer from "@tcomponents/Logs/components/LogsDrawer/LogsDrawer"
import FeatureButton from "@tcomponents/FeatureButton/FeatureButton"
import { COLLECTION_ADMINISTRATION_CODES } from "@constants/modules/collectionAdministration/collectionAdministrationCodes"

const { Paragraph } = Typography

const HistoryCollectionHeader = () => {
  const { param, location } = useCurrentLocation()
  const [openLogsDrawer, setOpenLogsDrawer] = useState(false)

  return (
    <header>
      <small className="history-collection-template-subtitle">
        ADMINISTRACIÓN DE COBROS / HISTORIAL DE COBROS
      </small>
      <CustomNavigate title={
        <Paragraph
          className='history-collection-template-title'
          ellipsis
        >
          HISTORIAL DE COBROS / {location.state?.currentCharge?.name?.toUpperCase()}
        </Paragraph>
      }>
        <Row className="history-template-collection-header" style={{ gap: 16 }} align="middle">
          <FeatureButton
            code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_CHECK_LOGS_HISTORY_COLLECTION}
            className="btn-standard-white btn-logs-disabled"
            style={{
              borderRadius: '50%',
              width: 42,
              height: 40,
            }} icon={<HistoryIcon />}
            popoverProps={{ 
              placement: 'bottomRight',
             }}
            onClick={() => setOpenLogsDrawer(true)}
          >
          </FeatureButton>
          <LogsDrawer
            isOpen={openLogsDrawer}
            onClose={() => setOpenLogsDrawer(false)}
            redirectTo="/logs/history-collection"
            service="/charge/instance/log"
            logsParams={{
              charge_id: param.templateId
            }}
          />
        </Row>
      </CustomNavigate>
    </header>
  )
}

export default HistoryCollectionHeader
